import styled from 'styled-components';

export const ArchivedSearchDisplayResultsLabelStyled = styled('label')`
  display: block;
  font-size: 1rem;
  margin-bottom: 1rem;
  transition: opacity 0.3s;

  &.loading {
    opacity: 0.5;
  }
`;
